import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VTooltip from 'v-tooltip'
import { rtdbPlugin } from 'vuefire'
import './fb/firebase'
import VueIntro from 'vue-introjs'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import VueGtag from "vue-gtag";
import OneSignalVue from 'onesignal-vue'
import { reportEvent} from './helpers/utils'

import Lang from 'vuejs-localization'
Lang.requireAll(require.context('./lang', true, /\.js$/))

Vue.use(VTooltip)
VTooltip.options.defaultTrigger = 'hover focus click'
VTooltip.options.autoHide = false
Vue.use(Lang)
Vue.use(VueIntro)

Vue.config.productionTip = false
Vue.use(rtdbPlugin)

Vue.use(VueFacebookPixel)
Vue.use(OneSignalVue)
Vue.analytics.fbq.init('1799509053547580')
Vue.use(VueGtag, {
  config: { id: "AW-311471832" },
  onReady () {
    console.log('gtag is ready');
  }
});

// android stub
/*window.Android = {
  sendJsMsgToWebView() {
    console.log('sendJsMsgToWebView');
  },
  sendJsMsgToWebViewForPermission() {
    console.log('sendJsMsgToWebViewForPermission');
  }
}*/

new Vue({
  router,
  render: h => h(App),
  beforeMount() {
    this.$OneSignal.init({
      appId: '0130663a-bce4-48e6-b3a0-9f25cd3ac110',
      safari_web_id: 'web.onesignal.auto.1f7bf174-83d3-440c-93ed-a44b9d28ad31',
    });
    this.$OneSignal.on('popoverShown', function() {
      console.log('Slide Prompt Shown');
    });
    this.$OneSignal.on('popoverAllowClick', function() {
      reportEvent('popoverClick', {oneSignalEnable: true});
    });
    this.$OneSignal.on('popoverCancelClick', function() {
      reportEvent('popoverClick', {oneSignalEnable: false});
    });
    this.$OneSignal.on('subscriptionChange', function(isSubscribed) {
      console.log("The user's subscription state is now:", isSubscribed);
    });
  }
}).$mount('#app')

